import React from 'react';

import { useTranslation } from "react-i18next";

import logo from '../img/logow.png'

const { hostname } = document.location;

function Footer() {

  const { t } = useTranslation();

  return (
    <div className='bg-[#000] z-10 relative'>
      <div className='flex flex-col xl:flex-row container mx-auto pt-[160px]'>
        <img src={logo} alt="" className='w-[80px] h-[40px]'/>
        <div className='ml-[30px] xl:ml-[150px] gap-[15px] flex flex-col mt-[30px] xl:mt-0'>
          <p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer1')} +41415331596</p>
          <div>
            <p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer2')} Limmatquai 4, 8001 Zürich, Switzerland</p>
          </div>
          <p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer3')} support@{hostname}</p>
        </div>
        <div className='ml-[30px] xl:ml-[450px] gap-[15px] flex flex-col mt-[15px] xl:mt-0'>
          <a href="/docs/client.pdf"><p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer4')}</p></a>
          <a href="/docs/policy.pdf"><p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer5')}</p></a>
          <a href="/docs/conflicts.pdf"><p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer6')}</p></a>
          <a href="/docs/fca.pdf"><p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>FCA</p></a>
          <a href="/docs/ifcsa.pdf"><p className='text-[#FFFFFFB2] roboto text-[14px] xl:text-[16px] font-normal'>IFCSA</p></a>
        </div>
      </div>
      <div className='flex flex-col container mx-auto pl-[30px] xl:pl-[230px] pt-[40px]'>
        <p className='text-[#FFFFFFB2] roboto text-[12px] font-light'>{t('footer7')}</p>
        <p className='text-[#FFFFFFB2] roboto text-[12px] font-light mt-[6px] pr-[30px] xl:pr-0'>{t('footer8')}</p>
        <p className='flex justify-end pb-[150px] mt-[14px] roboto text-[16px] text-[#FFFFFFB2] pr-[30px] xl:pr-0'>Stellar Hub © 2024. All rights reserved.</p>      
      </div>
    </div>
  );
}

export default Footer;